import React from 'react';
import Controller from './controller/controller';

import classes from './burgercontroller.module.css';


const controlls = [
    { label : 'Salad' , type : 'salad'},
    { label : 'Cheese' , type : 'cheese'},
    { label : 'Meat' , type : 'meat'},
    { label : 'Bacon' , type : 'bacon'}
];

const BurgerControllers = (props) => {
    return (
        <div className={classes.Controllers}>
            <p>Total Price : <strong>{props.price.toFixed(2)}</strong></p>
            { controlls.map((ctl,index) => (
                <Controller key={ctl.label} label={ctl.label} type={ctl.type} 
                handler={() => props.handler(ctl.type)}
                rmHandler={() => props.rmHandler(ctl.type)}
                disable={props.disable[index]}/> 
            ))}
            <button className={classes.OrderButton} 
            disabled={props.isPurchasable === 0} onClick={props.modalSummary}>
                <span className="material-icons" style={{verticalAlign:'middle'}}>payment</span>ORDER NOW</button>
        </div>
    );
}

export default BurgerControllers;